export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  CALLBACK: '/callback',
  CHECK_IN: '/check-in',
  COMPLETE: '/complete',
  LANDING: '/landing',
};
